import HelmetComponent from 'Components/Helmet';
import SimplifiedEditor from 'Components/RichEditor/SimplifiedEditor';
import useGetDomainTracking from 'store/services/helperHooks/useGetDomainTracking';
import { useStaticPageQuery } from 'store/services/staticPage';
import Title from 'style-guide/Typography/Title';
import getTitle from './getTitle';
import StaticPagesWrapper from './style/StaticPagesWrapper';

const StaticPages = ({ staticPageKey }) => {
  const { data } = useStaticPageQuery({ key: staticPageKey }, { refetchOnMountOrArgChange: true });
  const { data: domainData } = useGetDomainTracking();

  return (
    <StaticPagesWrapper className='row'>
      <HelmetComponent title={`${getTitle(staticPageKey)} | ${domainData?.brandName}`} />
      <div className='offset-lg-2 col-lg-8 offset-1 col-10'>
        <Title variant={5} className='static-page-title'>
          {getTitle(staticPageKey)}
        </Title>
        <SimplifiedEditor content={data?.content} editable={false} />
      </div>
    </StaticPagesWrapper>
  );
};

export default StaticPages;
